import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n';
import { trackEvent } from '../analytics';
import './AtelierDHeloise.css';

const COPY = {
  fr: {
    back: 'Retour au portfolio',
    tags: ['Réalisation client', 'Création', 'Boutique & gestion'],
    eyebrow: 'L’Atelier d’Héloïse / Création web',
    statement: 'Un métier créatif mérite un site qui lui ressemble.',
    screenshotLabel: 'Aperçu de l’univers de L’Atelier d’Héloïse',
    solutionTitle: 'Un site pour montrer son travail. Et faire tourner l’activité.',
    reviewEyebrow: 'Ce qu’en dit Héloïse',
    reviewSource: 'Avis original sur Codeur.com',
    detailLabel: 'En savoir plus sur la réalisation',
    technologiesLabel: 'Socle utilisé',
    ctaTitle: 'Et si on imaginait le vôtre ?',
    ctaText: 'Une boutique, des réservations, un espace de gestion : chaque activité a ses priorités. Estimez une première version, ou parlez-moi de votre projet pour chiffrer un périmètre complet.',
    ctaPrimary: 'Estimer une première version',
    ctaSecondary: 'Me parler de votre activité',
    liveLabel: 'Visiter le site d’Héloïse',
    title: 'L’Atelier d’Héloïse',
    intro: 'Les créations et les prestations d’Héloïse avaient besoin d’un univers à part entière, mais aussi d’une façon simple de gérer ce qui se passe derrière.',
    needTitle: 'Le besoin',
    need: 'Faire découvrir un travail artistique, permettre à ses clients de choisir une prestation ou une création, et éviter de disperser commandes, réservations et gestion entre plusieurs outils.',
    cards: [
      ['Faire découvrir et choisir', 'Un catalogue, des prestations et des parcours pour commander ou réserver selon le besoin.'],
      ['Gérer derrière le site', 'Les contenus, les commandes, les stocks, les devis et les factures se retrouvent dans un espace de gestion.'],
      ['Rester autonome', 'Une interface pour mettre à jour les informations et suivre les demandes au quotidien.'],
    ],
    proofTitle: 'Le résultat',
    proof: 'Un univers web qui met en valeur les créations d’Héloïse, associé à une boutique, aux réservations et à un espace de gestion pensé pour son activité.',
    visit: 'Voir le site',
    meta: 'L’Atelier d’Héloïse : réalisation d’un site pour présenter ses créations, gérer les commandes et les réservations de ses clients.',
  },
  en: {
    back: 'Back to portfolio',
    tags: ['Client project', 'Creative work', 'Shop & operations'],
    eyebrow: 'L’Atelier d’Héloïse / Web design & development',
    statement: 'Creative work deserves a website with its own character.',
    screenshotLabel: 'Preview of L’Atelier d’Héloïse',
    solutionTitle: 'A website to show the work. And support the business.',
    reviewEyebrow: 'Héloïse in her own words',
    reviewSource: 'Original review on Codeur.com',
    detailLabel: 'More about this project',
    technologiesLabel: 'Technology',
    ctaTitle: 'What could yours look like?',
    ctaText: 'A shop, booking and business tools each bring different needs. Estimate a first version, or contact me for a full-scope quote.',
    ctaPrimary: 'Estimate a first version',
    ctaSecondary: 'Tell me about your business',
    liveLabel: 'Visit Héloïse’s website',
    title: 'L’Atelier d’Héloïse',
    intro: 'Héloïse’s creative work needed a distinctive place online — with practical tools to handle the day-to-day behind it.',
    needTitle: 'The need',
    need: 'Avoid multiplying tools and give an independent business one coherent flow to present its work, sell, receive bookings and manage the operations behind the website.',
    cards: [
      ['Showcase and choose', 'A catalogue, services and flows to order or book based on what customers need.'],
      ['Manage the business', 'Content, orders, stock, quotes and invoices brought into one admin interface.'],
      ['Stay independent', 'An interface to update content and keep track of the business day to day.'],
    ],
    proofTitle: 'The result',
    proof: 'A distinctive place for Héloïse’s creative work, alongside a shop, booking flows and day-to-day management tools.',
    visit: 'Visit website',
    meta: 'A website created for L’Atelier d’Héloïse: showcasing creative work, orders, bookings and day-to-day business management.',
  },
  pt: {
    back: 'Voltar ao portfólio',
    tags: ['Projeto real', 'Atividade criativa', 'Loja e gestão'],
    eyebrow: 'L’Atelier d’Héloïse / Desenvolvimento web',
    statement: 'O trabalho criativo merece um site com personalidade.',
    screenshotLabel: 'Prévia do universo do L’Atelier d’Héloïse',
    solutionTitle: 'Um site para mostrar o trabalho. E facilitar o dia a dia.',
    reviewEyebrow: 'Nas palavras de Héloïse',
    reviewSource: 'Avaliação original no Codeur.com',
    detailLabel: 'Mais sobre o projeto',
    technologiesLabel: 'Tecnologias',
    ctaTitle: 'E se criássemos o seu?',
    ctaText: 'Loja, reservas e gestão exigem funcionalidades diferentes. Estime uma primeira versão ou fale comigo para orçamentar o projeto completo.',
    ctaPrimary: 'Estimar uma primeira versão',
    ctaSecondary: 'Falar da minha atividade',
    liveLabel: 'Visitar o site de Héloïse',
    title: 'L’Atelier d’Héloïse',
    intro: 'O trabalho criativo de Héloïse precisava de um espaço próprio e de ferramentas práticas para o dia a dia.',
    needTitle: 'A necessidade',
    need: 'Evitar a multiplicação de ferramentas e dar a uma profissional independente um percurso coerente para apresentar a atividade, vender, receber reservas e gerir as operações do site.',
    cards: [
      ['Mostrar e escolher', 'Catálogo, serviços e percursos para comprar ou reservar conforme a necessidade.'],
      ['Gerir nos bastidores', 'Conteúdos, pedidos, stock, orçamentos e faturas no mesmo espaço de gestão.'],
      ['Manter autonomia', 'Uma interface para atualizar conteúdos e acompanhar a atividade no dia a dia.'],
    ],
    proofTitle: 'O resultado',
    proof: 'Um universo que valoriza as criações de Héloïse, com loja, reservas e ferramentas para gerir a atividade.',
    visit: 'Ver o site',
    meta: 'Site criado para o L’Atelier d’Héloïse: apresentação de criações, reservas, pedidos e gestão diária.',
  },
};

export default function AtelierDHeloise() {
  const { lang } = useLang();
  const t = COPY[lang] || COPY.fr;

  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content');

    document.title = `${t.title} | ${t.tags[0]} | Alioune Seck`;
    description?.setAttribute('content', t.meta);
    trackEvent('acquisition_page_view', { page_type: 'client_project', project: 'atelier' });

    return () => {
      document.title = previousTitle;
      if (description && previousDescription) description.setAttribute('content', previousDescription);
    };
  }, [t]);

  return (
    <div className="portfolio-v2 atelier-case">
      <header className="atelier-case-nav">
        <Link className="v2-brand" to="/">
          <span className="v2-brand-symbol">AS</span>
          <span><strong>Alioune Seck</strong><small>{lang === 'fr' ? 'Développeur web freelance' : 'Freelance web developer'}</small></span>
        </Link>
        <Link className="atelier-case-return" to="/">{t.back} ↗</Link>
      </header>

      <main>
        <section className="atelier-case-hero" aria-labelledby="atelier-case-title">
          <div className="atelier-case-hero-text">
            <span className="v2-kicker">{t.eyebrow}</span>
            <h1 id="atelier-case-title">L’Atelier <em>d’Héloïse.</em></h1>
            <p className="atelier-case-statement">{t.statement}</p>
            <p className="atelier-case-intro">{t.intro}</p>
            <div className="atelier-case-tags" aria-label={t.tags[0]}>
              {t.tags.map((tag) => <span key={tag}>{tag}</span>)}
            </div>
          </div>
          <figure className="atelier-case-cover">
            <img src="/projects-v2/atelier.webp" alt={t.screenshotLabel} loading="eager" />
            <figcaption>{t.screenshotLabel}</figcaption>
          </figure>
        </section>

        <section className="atelier-case-need" aria-labelledby="atelier-case-need-title">
          <div><span className="v2-kicker">01 / {t.needTitle}</span></div>
          <h2 id="atelier-case-need-title">{t.need}</h2>
        </section>

        <section className="atelier-case-work" aria-labelledby="atelier-case-solution-title">
          <div className="atelier-case-section-head">
            <span className="v2-kicker">02 / {t.proofTitle}</span>
            <h2 id="atelier-case-solution-title">{t.solutionTitle}</h2>
          </div>
          <div className="atelier-case-grid">
            {t.cards.map(([title, text], index) => (
              <article key={title} className="atelier-case-card">
                <span>0{index + 1}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="atelier-case-review" aria-labelledby="atelier-case-review-title">
          <div><span className="v2-kicker">{t.reviewEyebrow}</span></div>
          <div>
            <span className="atelier-case-review-stars" aria-hidden="true">★★★★★</span>
            <h2 id="atelier-case-review-title">« Je repars avec un beau site et de la motivation pour continuer ! »</h2>
            <p>Héloïse · L’Atelier d’Héloïse · 5 octobre 2026</p>
            <a href="https://www.codeur.com/-aliounebp6ax" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('external_profile_click', { platform: 'codeur', placement: 'atelier_case' })}>{t.reviewSource} ↗</a>
          </div>
        </section>

        <section className="atelier-case-outcome" aria-labelledby="atelier-case-outcome-title">
          <span className="v2-kicker">03 / {t.proofTitle}</span>
          <h2 id="atelier-case-outcome-title">{t.proof}</h2>
          <a className="atelier-case-site-link" href="https://www.atelierdheloise.fr/" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('project_click', { project: 'atelier', placement: 'case_external' })}>{t.liveLabel} ↗</a>
        </section>

        <section className="atelier-case-cta">
          <span className="v2-kicker">Alioune Seck / {t.tags[0]}</span>
          <h2>{t.ctaTitle}</h2>
          <p>{t.ctaText}</p>
          <div className="atelier-case-actions">
            <Link className="v2-primary" to="/estimer-mon-projet?goal=sell" onClick={() => trackEvent('cta_click', { placement: 'atelier_case', target: 'estimator' })}>{t.ctaPrimary} →</Link>
            <a className="atelier-case-email" href="mailto:contact@alioune-seck.dev?subject=Parlons%20de%20mon%20projet" onClick={() => trackEvent('cta_click', { placement: 'atelier_case', target: 'email' })}>{t.ctaSecondary} ↗</a>
          </div>
        </section>
      </main>
      <footer className="atelier-case-footer"><span>Alioune Seck</span><Link to="/">{t.back} ↑</Link></footer>
    </div>
  );
}
